import { render } from "./BaseSpinner.vue?vue&type=template&id=13dbccfb"
import script from "./BaseSpinner.vue?vue&type=script&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&lang=js"

import "./BaseSpinner.vue?vue&type=style&index=0&id=13dbccfb&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__